export interface TemplateInventoryItem {
  name: string;
  category: "guest_amenities" | "cleaning_supplies" | "kitchen" | "general";
  unit: string;
  defaultQty: number;
}

export const INVENTORY_TEMPLATES: TemplateInventoryItem[] = [
  { name: "Toilet paper", category: "guest_amenities", unit: "rolls", defaultQty: 6 },
  { name: "Paper towels", category: "guest_amenities", unit: "rolls", defaultQty: 2 },
  { name: "Hand soap", category: "guest_amenities", unit: "bottles", defaultQty: 2 },
  { name: "Shampoo", category: "guest_amenities", unit: "bottles", defaultQty: 2 },
  { name: "Conditioner", category: "guest_amenities", unit: "bottles", defaultQty: 2 },
  { name: "Body wash", category: "guest_amenities", unit: "bottles", defaultQty: 2 },
  { name: "Dish soap", category: "kitchen", unit: "bottles", defaultQty: 1 },
  { name: "Dishwasher pods", category: "kitchen", unit: "pods", defaultQty: 12 },
  { name: "Coffee pods", category: "kitchen", unit: "pods", defaultQty: 12 },
  { name: "Sugar packets", category: "kitchen", unit: "packets", defaultQty: 20 },
  { name: "Garbage bags", category: "cleaning_supplies", unit: "bags", defaultQty: 10 },
  { name: "Laundry pods", category: "cleaning_supplies", unit: "pods", defaultQty: 8 },
  { name: "Sponges", category: "cleaning_supplies", unit: "count", defaultQty: 3 },
  { name: "Toilet brush replacements", category: "cleaning_supplies", unit: "count", defaultQty: 2 },
];

export const INVENTORY_CATEGORY_LABELS: Record<TemplateInventoryItem["category"], string> = {
  guest_amenities: "Guest amenities",
  cleaning_supplies: "Cleaning supplies",
  kitchen: "Kitchen",
  general: "General",
};

export function inventoryScopeForCategory(
  category: TemplateInventoryItem["category"]
): "unit" | "guest_amenities" | "supply_closet" {
  if (category === "guest_amenities") return "guest_amenities";
  return "supply_closet";
}
